module.exports = __webpack_public_path__ + "media/images/fig_07days-9bd40b510c744e59ec00937cabc38377.png";